import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { notificationsThunk } from "../../../store/actions/notifications/notification.thunk";
import moment from "moment";

import { PageBody } from "../../../components/loader";
import { useLoadingMessage } from "../../../components/useLoadingMessage";
import { ApiService } from "../../../services/ApiService";

export const Notification = () => {
  // const {user} = useContext(AuthContext)
  const { isLoading, message, updateLoader } = useLoadingMessage();
  const { notifications, others, last, next, prev, currentPage, perPage } =
    useSelector((state) => state.notifications);
  const [notification, setNotification] = useState("");
  const dispatch = useDispatch();

  // const [hasMoreItems, sethasMoreItems] = useState(true);

  // console.log("notifications", notifications);

  const getAllNotification = useCallback(async () => {
    updateLoader(true, "Getting all notifications");
    await dispatch(notificationsThunk.getAllNotifications());
    updateLoader(false);
  }, [dispatch]);

  // const getReadNotification = useCallback(async (id) => {
  //   await dispatch(notificationsThunk.getAllNotifications(id));
  // }, [dispatch]);

  const readNotification = async (id) => {
    await ApiService.get(`notifications/mark-as-read/${id}`);
    await dispatch(notificationsThunk.getUnreadNotifications());
    await dispatch(notificationsThunk.getAllNotifications());
  };

  // const showItems = (notification) => {
  //   let items = [];
  //   notification.map((notification, i) =>
  //     items.push(
  //       <div
  //         key={i}
  //         onClick={() => setNotification(notification.notifications)}
  //         className="chat_list"
  //         id="active_chat_{{$index}}"
  //       >
  //         <input
  //           type="hidden"
  //           value="{{ $notification->id }}"
  //           id="notification_id_{{$index}}"
  //         />
  //         <div className="chat_people">
  //           <div className="chat_ib">
  //             <h5>
  //               NEEDLE INTERNAL SOLUTION
  //               <span className="chat_date">
  //                 {moment(notification.created_at).fromNow()}
  //               </span>
  //             </h5>
  //             <p>{notification.subject}</p>
  //           </div>
  //         </div>
  //       </div>
  //     )
  //   );
  //   return items;
  // };

  // const loadMore = async () => {
  //   if (perPage === notifications.length) {
  //     sethasMoreItems(false);
  //     console.log("HELL");
  //   } else {
  //     console.log("HELL 222");
  //     await dispatch(notificationsThunk.getNextNotifications(next));
  //   }
  // };

  useEffect(() => {
    getAllNotification();
  }, []);
  return (
    <PageBody isLoading={isLoading} message={message}>
      <div className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="page-title-box-two">
                <h4 className="page-title"></h4>
                <h1 className="welcome_text">NOTIFICATIONS</h1>
                <div className="clearfix"></div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12 col-md-12 col-xs-12">
              <div className="card">
                <div className="rgba-black-strong py-5 px-4">
                  <div className="row d-flex justify-content-center">
                    <div className="col-md-12 col-xl-8"></div>
                  </div>
                  <div className="row">
                    <div className="col-xl-3 col-sm-6">
                      <div className="card-box-three widget-box-two widget-two-custom">
                        <div className="wigdet-two-content">
                          <p
                            className="m-0 text-uppercase font-bold font-secondary text-overflow"
                            title="Statistics"
                          >
                            Approved request
                          </p>

                          <p
                            className="m-0 text-uppercase font-bold"
                            align="left"
                          >
                            Leave :{" "}
                            <span>
                              <small>{others.approved_leave_requests}</small>
                            </span>
                          </p>
                          <p
                            className="m-0 text-uppercase font-bold"
                            align="left"
                          >
                            Office :{" "}
                            <span>
                              <small>{others.approved_office_requests}</small>
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="col-xl-3 col-sm-6">
                      <div className="card-box-three widget-box-two widget-two-custom">
                        <div className="wigdet-two-content">
                          <p
                            className="m-0 text-uppercase font-bold font-secondary text-overflow"
                            title="Statistics"
                          >
                            Pending Request
                          </p>

                          <p
                            className="m-0 text-uppercase font-bold"
                            align="left"
                          >
                            Leave :{" "}
                            <span>
                              <small>{others.pending_leave_requests}</small>
                            </span>
                          </p>
                          <p
                            className="m-0 text-uppercase font-bold"
                            align="left"
                          >
                            Office :{" "}
                            <span>
                              <small>{others.pending_office_requests}</small>
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="col-xl-3 col-sm-6">
                      <div className="card-box-three widget-box-two widget-two-custom">
                        <div className="wigdet-two-content">
                          <p
                            className="m-0 text-uppercase font-bold font-secondary text-overflow"
                            title="Statistics"
                          >
                            Rejected request
                          </p>

                          <p
                            className="m-0 text-uppercase font-bold"
                            align="left"
                          >
                            Leave :{" "}
                            <span>
                              <small>{others.rejected_leave_requests}</small>
                            </span>
                          </p>
                          <p
                            className="m-0 text-uppercase font-bold"
                            align="left"
                          >
                            Office :{" "}
                            <span>
                              <small>{others.rejected_office_requests}</small>
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="col-xl-3 col-sm-6">
                      <div className="card-box-three widget-box-two widget-two-custom">
                        <div className="wigdet-two-content">
                          <p className="m-0 text-uppercase font-bold font-secondary text-overflow">
                            Disciplinary Case
                          </p>

                          <p
                            className="m-0 text-uppercase font-bold"
                            align="left"
                          >
                            Open :{" "}
                            <span>
                              <small>{others.open_cases}</small>
                            </span>
                          </p>
                          <p
                            className="m-0 text-uppercase font-bold"
                            align="left"
                          >
                            Closed :{" "}
                            <span>
                              <small>{others.closed_cases}</small>
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* {notifications.map((not) => ( */}
                  <div className="row">
                    <div className="col-sm-12 col-md-12 col-xs-12">
                      <div className="container">
                        <h3 className=" text-center text-default">
                          NOTIFICATIONS
                        </h3>
                        <div className="messaging">
                          <div className="inbox_msg">
                            <div className="inbox_people">
                              <div className="headind_srch">
                                <div className="recent_heading">
                                  <h4>All</h4>
                                </div>
                              </div>
                              <div className="inbox_chat">
                                <div className="chat_list_wrapper">
                                  {/* {showItems(notifications)} */}
                                  {/* <InfiniteScroll
                                    loadMore={loadMore}
                                    hasMore={hasMoreItems}
                                    loader={
                                      <div className="loader"> Loading... </div>
                                    }
                                    useWindow={false}
                                  >
                                    {showItems(notifications)}
                                  </InfiniteScroll> */}
                                  {notifications.map((notification) => (
                                    <div
                                      onClick={() => {
                                        setNotification(notification.body);
                                        readNotification(notification.id);
                                      }}
                                      className={`chat_list ${
                                        notification.is_read > 0
                                          ? "bg-white"
                                          : ""
                                      }`}
                                      id="active_chat_{{$index}}"
                                    >
                                      <input
                                        type="hidden"
                                        value="{{ $notification->id }}"
                                        id="notification_id_{{$index}}"
                                      />
                                      <div className="chat_people">
                                        <div className="chat_ib">
                                          <h5>
                                            {notification.is_read < 1 ? (
                                              <strong>
                                                NEEDLE INTERNAL SOLUTION
                                              </strong>
                                            ) : (
                                              "NEEDLE INTERNAL SOLUTION"
                                            )}
                                            <span className="chat_date">
                                              {notification.is_read < 1 ? (
                                                <strong>
                                                  {moment(
                                                    notification.created_at
                                                  ).fromNow()}{" "}
                                                </strong>
                                              ) : (
                                                moment(
                                                  notification.created_at
                                                ).fromNow()
                                              )}
                                            </span>
                                          </h5>
                                          <p>
                                            {notification.is_read < 1 ? (
                                              <strong>
                                                {notification.subject}
                                              </strong>
                                            ) : (
                                              notification.subject
                                            )}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </div>

                            <div className="mesgs">
                              <div className="msg_history">
                                <div
                                  className="incoming_msg"
                                  id="notification_body"
                                >
                                  <span>{notification}</span>
                                  {/* <span
                                  id="notification_spinner"
                                  className="fa fa-spin fa-spinner"
                                ></span> */}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PageBody>
  );
};



// WEBPACK FOOTER //
// ./src/container/dashboard/notification/index.js